import { render, staticRenderFns } from "./DateField.vue?vue&type=template&id=520f7796&"
import script from "./DateField.vue?vue&type=script&lang=js&"
export * from "./DateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports